import * as IoC from 'typescript-ioc';
import { IApiClient, RequestContentType } from '../../infrastructure/api-client';
import { IAssetUrlDTO, IUploadRequestParams } from '../shared.dto';
import { IFileToS3DAO, UploadPathKey, UploadRequestParams } from '../file-to-s3.dao';
import { APPLICATION_OCTET_STREAM, FILE_UPLOAD_UNSUPPORTED_TYPE_ERROR_MESSAGE } from '../../constants/file.constants';

class FileToS3DAO extends IFileToS3DAO {
    static readonly paths: Record<UploadPathKey, string> = {
        passport: 'account/{accountId}/event/{eventId}/website/upload-url',
        attendee: 'account/{accountId}/event/{eventId}/attendee/upload-url',
        meeting: 'account/{accountId}/event/{eventId}/meetings/upload-url',
        'scheduled-emails': 'account/{accountId}/event/{eventId}/scheduled-emails/upload-url',
        'email-configuration': 'account/{accountId}/event/{eventId}/email-configuration/upload-url',
        eventHub: 'account/{accountId}/event-hub/{eventId}/branding/upload-url',
        event: 'account/{accountId}/event/{eventId}/upload-url',
        'account-contact': 'account/{accountId}/account-contact/upload-url',
        'rolodex-contact': 'api/v1/rolodex/contacts/{contactId}/upload-url',
    };

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getS3AssetUrl(params: UploadRequestParams, path: string): Promise<IAssetUrlDTO> {
        const response = await this.apiClient.get<IAssetUrlDTO>(path, params);
        return response.parsedResponse;
    }

    public async uploadFileToS3(file: File, params: UploadRequestParams, pathKey: UploadPathKey): Promise<IAssetUrlDTO> {
        if (!file.type || file.type === APPLICATION_OCTET_STREAM) {
            throw new Error(FILE_UPLOAD_UNSUPPORTED_TYPE_ERROR_MESSAGE(file.name));
        }
        const assetUrlParams = await this.getS3AssetUrl(params, FileToS3DAO.paths[pathKey]);
        const fileType = file.type as RequestContentType;
        await this.apiClient.put(assetUrlParams.assetUrl, file, {
            ContentType: fileType
        });
        return assetUrlParams;
    }

    public async uploadImageToS3(image: File, params: IUploadRequestParams, pathKey: UploadPathKey): Promise<IAssetUrlDTO> {
        return await this.uploadFileToS3(image, params, pathKey);
    }

}

export { FileToS3DAO };
